import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

import headerSearch from './components/headerSearch.js'
import imageStack from './components/imageStack.js'
import scrollReveal from './components/scrollReveal.js'
import stack3d from './components/stack3d.js'
import viewer3d from './components/viewer3d.js'
import headerScroll from './components/headerScroll.js'
import slider from './components/slider.js'
import scrollToTop from './components/scrollToTop.js'
import sliderMiniatures from './components/sliderMiniatures.js'

Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.plugin(collapse)
window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
	Alpine.data('headerSearch', headerSearch)
	Alpine.data('imageStack', imageStack)
	Alpine.data('scrollReveal', scrollReveal)
	Alpine.data('stack3d', stack3d)
	Alpine.data('viewer3d', viewer3d)
	Alpine.data('headerScroll', headerScroll)
	Alpine.data('slider', slider)
	Alpine.data('scrollToTop', scrollToTop)
	Alpine.data('sliderMiniatures', sliderMiniatures)
});

document.addEventListener("DOMContentLoaded", function(event) {
	Alpine.start();
});


